var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0b1a51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M4 11h22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0b1a51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M4 15h22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0b1a51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M4 19h22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.368413d8c98acdc2a6d4e482dfa0e925.svg";
export { ForwardRef as ReactComponent };